<app-card></app-card>


<div class="container" style="margin-bottom: 0;margin-top:3%;margin: 3rem; border: 1px solid #0076ce; ">
    <h2 class="dds__h2" style="font-weight: bold;margin: 1rem;">Hardware-Relationship Mapping
    </h2>
    <div class="dds__card_ed" style=" margin-top: 2rem; margin: 1rem;">

        <div class="dds__card_ed" style=" margin-top: 2rem; margin: 1rem;">
            <div class="tableFixHead">
                <form [formGroup]="harwareRelMappingForm">
                    <table id="tbl_bgr" style="border-collapse: unset;inline-size: -webkit-fill-available">
                        <thead>
                            <tr>
                                <th>Hardware - ComponentId <br>
                                    <input type="text" class="dds__form-control"
                                        style="margin-bottom: 1rem; width: 100%;"
                                        (ngModelChange)="filterComponentItem($event)" [(ngModel)]="filterComponentText"
                                        [ngModelOptions]="{standalone: true}" placeholder="Search Component">
                                </th>
                                <th>PnP ID String Info <br>
                                    <input type="text" class="dds__form-control"
                                        style="margin-bottom: 1rem; width: 100%;"
                                        (ngModelChange)="filterPnpIdsItem($event)" [(ngModel)]="filterPnpIdText"
                                        [ngModelOptions]="{standalone: true}" placeholder="Search PnP ID">
                                </th>
                                <th></th>
                                <th>Hardware - PnP Mapping<br>
                                    <input type="text" class="dds__form-control"
                                        style="margin-bottom: 1rem; width: 100%;"
                                        (ngModelChange)="filterHarwarePnpMapItem($event)"
                                        [(ngModel)]="filterHardwarePnpMappingText" [ngModelOptions]="{standalone: true}"
                                        placeholder="Search Hardware - PnP Mapping">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="width: 35%;">
                                    <select #selectComponentList name="componentId" id="componentId" multiple
                                        style="width: 100%;min-height:200px" formControlName="componentId">
                                        <option *ngFor="let component of componentIDs" [value]="component">{{component}}
                                        </option>
                                    </select>
                                </td>
                                <td style="width: 20%;">
                                    <select #selectPnpIdList name="pnpIdString" id="pnpIdString" multiple
                                        style="width: 100%; min-height:200px;" formControlName="pnpIdString">
                                        <option *ngFor="let pnpId of PnpIds" [value]="pnpId">{{pnpId}}</option>
                                    </select>
                                </td>
                                <td style="width: 5%; text-align: center;">
                                    <div>
                                        <a href="javascript:void(0)" style="width: 30%; text-decoration: none;">
                                            <i style="font-size: 1.5em; color: #006bbd;" tabindex="-1" role="button"
                                                aria-label="Add child"
                                                class="clickable dds__icons dds__arrow-tri-left bowtie-icon dds__icon-grid-item"
                                                aria-describedby="vss_21" (click)="unselectHardwareMappingValues()"></i>
                                        </a>
                                        <a href="javascript:void(0)" style="width: 30%; text-decoration: none;">
                                            <i style="font-size: 1.5em; color: #006bbd;" tabindex="-1" role="button"
                                                aria-label="Add child"
                                                class="clickable dds__icons dds__arrow-tri-right bowtie-icon dds__icon-grid-item"
                                                aria-describedby="vss_21" (click)="selectHardwareMappingValues()"></i>
                                        </a>

                                    </div>
                                </td>

                                <td style="width: 45%;">
                                    <select #selectHardwarePnpMapList name="hardwarePnpIdMapping"
                                        (ngModelChange)="onChangeOfOptionsOSLang($event)" id="hardwarePnpIdMapping"
                                        multiple style="width: 100%; min-height:200px;"
                                        formControlName="hardwarePnpIdMapping">
                                        <option *ngFor="let pnpMapping of hardwarePnpMappings" [value]="pnpMapping">
                                            {{pnpMapping}}</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            <br>
            <div class="text-center" style="display: flex; justify-content: flex-end;">
                <button type="button" class="dds__btn dds__btn-primary  dds__text-truncate"
                    (click)="confirmHarwareRelMappingValues()">Confirm
                </button>&nbsp;
                <button type="button" data-dismiss="dds__modal" aria-label="Close" class="dds__close"
                    (click)="onCancel()" class="dds__btn dds__btn-secondary dds__text-truncate">Cancel
                </button>

            </div>
        </div>
    </div>